import dayjs, { type Dayjs } from 'dayjs'
import { SelectedDate } from './types'
import { dateToCanonicalKey } from '../../utils/note'

export function dateToWeek(date: Dayjs): { week: number; year: number } {
  return { week: date.week(), year: date.year() }
}

export function weekToDate({
  date,
  week,
  year,
}: {
  date?: Dayjs
  week: number
  year: number
}): Dayjs {
  if (date && date.week() === week && date.year() === year) {
    return date
  }
  return dayjs().year(year).week(week)
}

export function selectedDateToDay(date?: SelectedDate): Dayjs {
  if (!date) return dayjs()
  if (date.activePeriod === 'week') {
    return weekToDate(date)
  }
  return date.date
}

export function selectedDateToWeek(date: SelectedDate): {
  week: number
  year: number
} {
  if (date.activePeriod === 'week') {
    return { week: date.week, year: date.year }
  }
  return dateToWeek(date.date)
}

export function selectedDateToKey(date: SelectedDate): string {
  const options =
    date.activePeriod === 'week'
      ? { week: date.week, weekYear: date.year }
      : undefined

  return dateToCanonicalKey(date.date, date.activePeriod, options)
}

export function isSameWeek(
  a: SelectedDate,
  b: { week: number; year: number }
): boolean {
  if (a.activePeriod === 'day') {
    return a.date.week() === b.week && a.date.year() === b.year
  }
  return a.week === b.week && a.year === b.year
}

export function isSameDay(a: SelectedDate, b: Dayjs): boolean {
  if (a.activePeriod === 'day') {
    return a.date.isSame(b, 'day')
  }
  return false
}
